/*
 * Copyright 2026 NXGN Management, LLC. All Rights Reserved.
 */

export interface MerchantApplicationRequest {
  legal_name: string;
  pricing_profile: string;
  software_name: string;
  primary_contact: {
    first_name: string;
    last_name: string;
    email: string;
  };
  merchants: { dba: string }[];
}

export interface OnboardingProfiles {
  pricing_profiles: string[];
  software_names: string[];
}
